<template>
    <div>
      <b-row class="card mt-5">
        <div class="w-100">
          <h5 class="title-card">
            <i class="fas fa-solar-panel"></i> Dados do painel
          </h5>
        </div>
        <div class="w-100 p-3">
          <b-form>
            <b-row>
              <b-col lg="8">
                <b-form-group label="Modelo">
                  <b-form-input
                    :class="{ 'form-group--error': $v.payload.model.$error }"
                    v-model="$v.payload.model.$model"
                    :state="$v.payload.model.$dirty ?
                    !$v.payload.model.$error : null"
                  />
                  <b-form-invalid-feedback>
                    Preenchimento obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="3">
                <b-form-group label="Potência (KW)">
                  <b-form-input
                    :class="{ 'form-group--error': $v.payload.power.$error }"
                    v-model="$v.payload.power.$model"
                    :state="$v.payload.power.$dirty ?
                    !$v.payload.power.$error : null"
                  />
                  <b-form-invalid-feedback>
                    Preenchimento obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="3">
                <b-form-group label="Área">
                  <b-form-input
                    :class="{ 'form-group--error': $v.payload.dimensions.$error }"
                    v-model="$v.payload.dimensions.$model"
                    :state="$v.payload.dimensions.$dirty ?
                    !$v.payload.dimensions.$error : null"
                  />
                  <b-form-invalid-feedback>
                    Preenchimento obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="3">
                <b-form-group label="Marca">
                  <b-form-input
                    :class="{ 'form-group--error': $v.payload.brand.$error }"
                    v-model="$v.payload.brand.$model"
                    :state="$v.payload.brand.$dirty ?
                    !$v.payload.brand.$error : null"
                  />
                  <b-form-invalid-feedback>
                    Preenchimento obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="3">
                <b-form-group label="Preço custo">
                  <money
                    class="form-control"
                    :class="{ 'form-group--error': $v.payload.price.$error }"
                    v-model="$v.payload.price.$model"
                    :state="$v.payload.price.$dirty ?
                    !$v.payload.price.$error : null"
                    v-bind="money"
                  />
                  <b-form-invalid-feedback>
                    Preenchimento obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="2">
                <b-form-group label="Status">
                  <b-form-select :options="status" v-model="payload.active"></b-form-select>
                </b-form-group>
              </b-col>

                <div class="w-100 text-left mt-3">
                    <b-button class="ml-3" variant="success" @click="save(false)">Salvar</b-button>
                    <b-button class="ml-3" variant="primary" v-if="!id" @click="save(true)">Salvar e continuar</b-button>
                </div>
            </b-row>
          </b-form>
        </div>
      </b-row>
    </div>
  </template>

<script>
import { required } from 'vuelidate/lib/validators';
import { Money } from 'v-money';
import MessagesMixin from '@/mixins/messages-mixin';
import QuestionMixin from '@/mixins/question-mixin';
import ErrorMixin from '@/mixins/error-mixin';
import PanelService from '../../../Services/PanelService';

export default {
  props: ['id'],
  components: {
    Money,
  },
  mixins: [MessagesMixin, QuestionMixin, ErrorMixin],
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false, /* doesn't work with directive */
      },
      status: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      payload: {
        model: '',
        power: '',
        dimensions: '',
        brand: '',
        price: '',
      },
    };
  },
  validations: {
    payload: {
      model: { required },
      power: { required },
      dimensions: { required },
      brand: { required },
      price: { required },
    },
  },
  methods: {
    async getPanel() {
      try {
        const { data } = await PanelService.get(this.id);
        this.payload = data;
      } catch (error) {
        this.error(error);
      }
    },
    resertForm() {
      this.payload = {
        model: '',
        power: '',
        brand: '',
        dimensions: '',
        price: '',
      };
      this.$v.payload.$reset();
    },
    async save(continueSave) {
      this.$v.payload.$touch();
      if (!this.$v.payload.$invalid) {
        try {
          const { data } = await this.id ? PanelService.edit(this.payload) : PanelService.save(this.payload);
          console.log(data);

          if (this.id) {
            this.messageSuccess('Painel editado com sucesso!');
          } else {
            this.messageSuccess('Painel cadastrado com sucesso!');
          }

          if (continueSave && !this.id) {
            this.resertForm();
          } else {
            this.$router.push({ name: 'panel' });
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  created() {
    if (this.id) {
      this.getPanel();
    }
  },
};
</script>
